const BASE_URL = "http://localhost:2024";

export const statusCodes = [
  { code: "200", name: "OK", description: "Everything worked as expected." },
  {
    code: "400",
    name: "Bad Request",
    description:
      "The request was unacceptable, often due to missing a required parameter.",
  },
  {
    code: "401",
    name: "Unauthorized",
    description: "No valid API key provided.",
  },
  {
    code: "402",
    name: "Request Failed",
    description: "The parameters were valid but the request failed.",
  },
  {
    code: "403",
    name: "Forbidden",
    description: "The API key doesn't have permissions to perform the request.",
  },
  {
    code: "404",
    name: "Not Found",
    description: "The requested resource doesn't exist.",
  },
  {
    code: "500, 502, 503, 504",
    name: "Server Errors",
    description: "Something went wrong on server. (These are rare.)",
  },
];

export const errorTypes = [
  {
    type: "api_error",
    description:
      "API errors cover any other type of problem (e.g., a temporary problem with servers), and are extremely uncommon.",
  },
  {
    type: "invalid_request_error",
    description:
      "Invalid request errors arise when your request has invalid parameters.",
  },
];

export const endpoints = {
  Auth: [
    {
      name: "Generate Token",
      url: `${BASE_URL}/api/v1/auth/token`,
      method: "POST",
      description: "Create an authentication token for API access",
    },
  ],

  //   Leads: [
  //     {
  //       name: "List",
  //       url: `${BASE_URL}api/vendor/leads?isActive=true&keyword=&page=1&limit=10&{vendorId}`,
  //       method: "GET",
  //       description: "Retrieve a paginated list of Customer Leads",
  //     },
  //   ],
  Shipments: [
    {
      name: "Create",
      url: `${BASE_URL}/api/v1/shipments`,
      method: "POST",
      description: "Create a new shipment in the system",
    },
    {
      name: "List",
      url: `${BASE_URL}/api/v1/shipments/`,
      method: "GET",
      description: "Retrieve a paginated list of shipments",
    },
    {
      name: "Detail",
      url: `${BASE_URL}/api/v1/shipments/{shipmentId}`,
      method: "GET",
      description: "Get detail of individual shipment",
    },
  ],

  //   Coupon: [
  //     {
  //       name: "Create",
  //       url: `${BASE_URL}/api/vendor/coupons/coupon-create`,
  //       method: "POST",
  //       description: "Create a new Coupon in the system",
  //     },
  //     {
  //       name: "List",
  //       url: `${BASE_URL}/api/vendor/shipments/list?page=1&limit=10`,
  //       method: "GET",
  //       description: "Retrieve a paginated list of Coupones",
  //     },
  //     {
  //       name: "Edit",
  //       url: `${BASE_URL}/api/vendor/shipments/{couponId}`,
  //       method: "PUT",
  //       description: "Update an existing Coupon by ID",
  //     },
  //   ],
  //   Products: [
  //     {
  //       name: "Create",
  //       url: `${BASE_URL}/api/vendor/products`,
  //       method: "POST",
  //       description: "Create a new product in the system",
  //     },
  //     {
  //       name: "List",
  //       url: `${BASE_URL}/api/vendor/products/list?page=1&limit=10`,
  //       method: "GET",
  //       description: "Retrieve a paginated list of products",
  //     },
  //     {
  //       name: "Edit",
  //       url: `${BASE_URL}/api/vendor/products/{productId}`,
  //       method: "PUT",
  //       description: "Update an existing product by ID",
  //     },
  //   ],
  //   Category: [
  //     {
  //       name: "Create",
  //       url: `${BASE_URL}/api/vendor/categories`,
  //       method: "POST",
  //       description: "Create a new category in the system",
  //     },
  //     {
  //       name: "List",
  //       url: `${BASE_URL}/api/vendor/categories/list?status=Active&page=1&limit=10`,
  //       method: "GET",
  //       description: "Retrieve a paginated list of categories",
  //     },
  //     {
  //       name: "Edit",
  //       url: `${BASE_URL}/api/vendor/categories/{categoryId}`,
  //       method: "PUT",
  //       description: "Update an existing category by ID",
  //     },
  //   ],
};

export const requestBodies = {
  Auth: {
    "Generate Token": JSON.stringify(
      {
        apiKey: "MEDXXXXXXXXXXXXX",
        secretKey: "UK8XXXXXXXXXXXXX",
      },
      null,
      2,
    ),
  },
  Shipments: {
    Create: JSON.stringify(
      {
        sourceBranch: "Dolpa",
        destinationBranch: "Janakpur",
        receiver: {
          name: "John Cena",
          phone: "9878767676",
        },
        codAmount: 2500,
        productDescription: "Electronics - Mobile Phone",
        reference: "ORD-55421",
        weight: 0.5,
      },
      null,
      2,
    ),
    Edit: JSON.stringify(
      {
        account: "66ade711ed3bb7773374aef4",
        entity: "66adf17a9eee5da87f5d6c4f",
        vendor: "67f4eeb6f9432667c4ba71f2",
        receiver: "67b44d6a0a3e58f73badc8a2",
        receiverAddress: "67b46ea5e4071061489aa3d7",
        branch: "66ade711ed3bb7773374aef4",
        destinationBranch: "676f9dc5d4b4125caf64e4f6",
        weight: "1",
        deliveryCharge: "1",
        codCharge: "1",
        deliverySecurity: "Normal",
        isActive: true,
      },
      null,
      2,
    ),
  },
  Products: {
    Create: JSON.stringify(
      {
        account: "66ade711ed3bb7773374aef4",
        entity: "66adf17a9eee5da87f5d6c4f",
        allowSaleBelowMOQ: false,
        categories: ["67f65024c9e7f8185ca63895", "67c6deb32c907d0275190a77"],
        crossedPrice: "10",
        hasVariant: false,
        isActive: true,
        moq: 1,
        productDescription: "<p>Description of product&nbsp;</p>",
        productImages: [
          {
            name: "240_F_603299144_OjuU1A6ifomwkKfQED20RxJmj9fAn1Ks.jpg",
            type: "image/jpeg",
            size: 43212,
          },
        ],
        productName: "Miranda Wilcox",
        productSku: "sku",
        quantity: "20",
        sellingPrice: 10,
        sellingUnit: "Piece",
        sizeOptions: [],
        variantOptions: [],
        variants: [],
        vendor: "67b326e9e0a8523ad8893cc7",
        weight: "1",
      },
      null,
      2,
    ),
    Edit: JSON.stringify(
      {
        account: "66ade711ed3bb7773374aef4",
        entity: "66adf17a9eee5da87f5d6c4f",
        allowSaleBelowMOQ: false,
        categories: ["67f65024c9e7f8185ca63895", "67c6deb32c907d0275190a77"],
        crossedPrice: "10",
        hasVariant: false,
        isActive: true,
        moq: 1,
        productDescription: "<p>Description of product&nbsp;</p>",
        productImages: [
          {
            name: "240_F_603299144_OjuU1A6ifomwkKfQED20RxJmj9fAn1Ks.jpg",
            type: "image/jpeg",
            size: 43212,
          },
        ],
        productName: "Miranda Wilcox",
        productSku: "sku",
        quantity: "20",
        sellingPrice: 10,
        sellingUnit: "Piece",
        sizeOptions: [],
        variantOptions: [],
        variants: [],
        vendor: "67b326e9e0a8523ad8893cc7",
        weight: "1",
      },
      null,
      2,
    ),
  },
  Category: {
    Create: JSON.stringify(
      {
        categoryName: "Noel Holcomb",
        categoryDescription: "<p>Category description</p>",
        isActive: true,
        packageType: {
          _id: "61b6d5a3bd5be8b26811132d",
          name: "Live Animals",
        },
        name: "Live Animals",
        _id: "61b6d5a3bd5be8b26811132d",
        vendor: "67b326e9e0a8523ad8893cc7",
      },
      null,
      2,
    ),
    Edit: JSON.stringify(
      {
        categoryName: "Noel Holcomb",
        categoryDescription: "<p>Category description</p>",
        isActive: true,
        packageType: {
          _id: "61b6d5a3bd5be8b26811132d",
          name: "Live Animals",
        },
        name: "Live Animals",
        _id: "61b6d5a3bd5be8b26811132d",
        vendor: "67b326e9e0a8523ad8893cc7",
      },
      null,
      2,
    ),
  },

  Coupon: {
    Create: JSON.stringify(
      {
        account: "66ade711ed3bb7773374aef4",
        entity: "66adf17a9eee5da87f5d6c4f",
        code: "Sint sint exercitat",
        description: "Sit molestiae rerum",
        discountType: "Percentage",
        discountValue: "18",
        expiryDate: "2025-05-03T19:06",
        isActive: true,
        maxDiscountAmount: "73",
        minPurchaseAmount: "8",
        usageLimit: "100",
        vendor: "67b326e9e0a8523ad8893cc7",
      },
      null,
      2,
    ),
    Edit: JSON.stringify(
      {
        account: "66ade711ed3bb7773374aef4",
        entity: "66adf17a9eee5da87f5d6c4f",
        code: "Quos nostrum sit rer",
        createdAt: "2025-04-11T09:55:36.060Z",
        description: "Dolore laudantium m",
        discountType: "Percentage",
        discountValue: "43",
        expiryDate: "2025-04-29T05:00",
        id: "67f8e7185cdfd4648f223c12",
        isActive: true,
        isExhausted: false,
        isExpired: false,
        maxDiscountAmount: "80",
        minPurchaseAmount: "25",
        shipments: [],
        status: "Active",
        updatedAt: "2025-04-11T09:55:36.060Z",
        usageLimit: "66",
        usedCount: 0,
        vendor: "67b326e9e0a8523ad8893cc7",
      },
      null,
      2,
    ),
  },
};

export const responseExamples = {
  Auth: {
    "Generate Token": JSON.stringify(
      {
        success: true,
        data: {
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9....",
          expiresIn: 3600,
          tokenType: "Bearer",
        },
      },
      null,
      2,
    ),
  },
  Products: {
    Create: JSON.stringify(
      {
        addedUser: "67b326f5e0a8523ad8893d0a",
        productName: "Miranda Wil543543cox",
        slug: "miranda-wil543543cox",
        productDescription: "<p>Description of product&nbsp;</p>",
        productImages: [
          {
            name: "240_F_603299144_OjuU1A6ifomwkKfQED20RxJmj9fAn1Ks.jpg",
            type: "image/jpeg",
            size: "43212",
            _id: "67f8a740eeb13afa68588b7c",
          },
        ],
        hasVariant: false,
        sellingPrice: 10,
        crossedPrice: 10,
        quantity: 20,
        weight: 1,
        moq: 1,
        sellingUnit: "Piece",
        productSku: "sku",
        isActive: true,
        categories: ["67f65024c9e7f8185ca63895", "67c6deb32c907d0275190a77"],
        variantOptions: [],
        sizeOptions: [],
        variants: [],
        vendor: "67b326e9e0a8523ad8893cc7",
        allowSaleBelowMOQ: false,
        _id: "67f8a740eeb13afa68588b7b",
        createdAt: "2025-04-11T05:23:12.496Z",
        updatedAt: "2025-04-11T05:23:12.496Z",
        __v: 0,
        outOfStock: false,
        id: "67f8a740eeb13afa68588b7b",
      },
      null,
      2,
    ),
    List: JSON.stringify(
      {
        data: [
          {
            _id: "67f8a740eeb13afa68588b7b",
            productName: "Miranda Wil543543cox",
            productDescription: "<p>Description of product&nbsp;</p>",
            productImages: [
              {
                name: "240_F_603299144_OjuU1A6ifomwkKfQED20RxJmj9fAn1Ks.jpg",
                type: "image/jpeg",
                size: "43212",
                _id: "67f8a740eeb13afa68588b7c",
              },
            ],
            hasVariant: false,
            sellingPrice: 10,
            crossedPrice: 10,
            quantity: 20,
            sellingUnit: "Piece",
            productSku: "sku",
            categories: [
              {
                _id: "67f65024c9e7f8185ca63895",
                categoryName: "Cattt",
              },
              {
                _id: "67c6deb32c907d0275190a77",
                categoryName: "Clothes",
              },
            ],
            allowSaleBelowMOQ: false,
            createdAt: "2025-04-11T05:23:12.496Z",
            updatedAt: "2025-04-11T05:23:12.496Z",
          },
          {
            _id: "67f89b44eeb13afa68588a9d",
            productName: "Miranda Wil55cox",
            productDescription: "<p>Description of product&nbsp;</p>",
            productImages: [
              {
                name: "240_F_603299144_OjuU1A6ifomwkKfQED20RxJmj9fAn1Ks.jpg",
                type: "image/jpeg",
                size: "43212",
                _id: "67f89b44eeb13afa68588a9e",
              },
            ],
            hasVariant: false,
            sellingPrice: 10,
            crossedPrice: 10,
            quantity: 20,
            sellingUnit: "Piece",
            productSku: "sku",
            categories: [
              {
                _id: "67f65024c9e7f8185ca63895",
                categoryName: "Cattt",
              },
              {
                _id: "67c6deb32c907d0275190a77",
                categoryName: "Clothes",
              },
            ],
            allowSaleBelowMOQ: false,
            createdAt: "2025-04-11T04:32:04.868Z",
            updatedAt: "2025-04-11T04:32:04.868Z",
          },
          {
            _id: "67f89476eeb13afa68588a93",
            productName: "Miranda Wil4cox",
            productDescription: "<p>Description of product&nbsp;</p>",
            productImages: [
              {
                name: "240_F_603299144_OjuU1A6ifomwkKfQED20RxJmj9fAn1Ks.jpg",
                type: "image/jpeg",
                size: "43212",
                _id: "67f89476eeb13afa68588a94",
              },
            ],
            hasVariant: false,
            sellingPrice: 10,
            crossedPrice: 10,
            quantity: 20,
            sellingUnit: "Piece",
            productSku: "sku",
            categories: [
              {
                _id: "67f65024c9e7f8185ca63895",
                categoryName: "Cattt",
              },
              {
                _id: "67c6deb32c907d0275190a77",
                categoryName: "Clothes",
              },
            ],
            allowSaleBelowMOQ: false,
            createdAt: "2025-04-11T04:03:02.268Z",
            updatedAt: "2025-04-11T04:03:02.268Z",
          },
          {
            _id: "67f892b3eeb13afa685889b5",
            productName: "Miranda Wilcox",
            productDescription: "<p>Description of product&nbsp;</p>",
            productImages: [
              {
                name: "240_F_603299144_OjuU1A6ifomwkKfQED20RxJmj9fAn1Ks.jpg",
                type: "image/jpeg",
                size: "43212",
                publicId:
                  "67b326e9e0a8523ad8893cc7/VendorProductImages/1744343730039.jpg",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/Vendor/67b326e9e0a8523ad8893cc7/VendorProductImages/1744343730039.jpg",
                _id: "67f892b3eeb13afa685889b6",
              },
            ],
            hasVariant: false,
            sellingPrice: 10,
            crossedPrice: 10,
            quantity: 20,
            sellingUnit: "Piece",
            productSku: "sku",
            categories: [
              {
                _id: "67f65024c9e7f8185ca63895",
                categoryName: "Cattt",
              },
              {
                _id: "67c6deb32c907d0275190a77",
                categoryName: "Clothes",
              },
            ],
            allowSaleBelowMOQ: false,
            createdAt: "2025-04-11T03:55:31.259Z",
            updatedAt: "2025-04-11T03:55:31.259Z",
          },
          {
            _id: "67f63c7410d1c32f372641b2",
            productName: "Jayme Farmer",
            productDescription: "<p>Enter Product Description dsa</p>",
            productImages: [
              {
                name: "240_F_603299144_OjuU1A6ifomwkKfQED20RxJmj9fAn1Ks.jpg",
                type: "image/jpeg",
                size: "43212",
                publicId:
                  "67b326e9e0a8523ad8893cc7/VendorProductImages/1744190579876.jpg",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/Vendor/67b326e9e0a8523ad8893cc7/VendorProductImages/1744190579876.jpg",
                _id: "67f63c7410d1c32f372641b3",
              },
            ],
            hasVariant: false,
            sellingPrice: 507,
            crossedPrice: 431,
            quantity: 449,
            sellingUnit: "Piece",
            productSku: "Eius totam incididun",
            categories: [
              {
                _id: "67c6deb32c907d0275190a77",
                categoryName: "Clothes",
              },
            ],
            allowSaleBelowMOQ: true,
            createdAt: "2025-04-09T09:23:00.783Z",
            updatedAt: "2025-04-09T09:23:00.783Z",
          },
          {
            _id: "67ebd403b6d7cb9f8a222d0f",
            productName: "Ivory Camacho",
            productDescription: "<p>Enter Product Descriptionr</p>",
            productImages: [
              {
                name: "1.png",
                type: "image/png",
                size: "53123",
                publicId:
                  "66adf17a9eee5da87f5d6c4f/VendorProductImages/1743508481678.png",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/66ade711ed3bb7773374aef4/66adf17a9eee5da87f5d6c4f/VendorProductImages/1743508481678.png",
                _id: "67ebd403b6d7cb9f8a222d10",
              },
            ],
            hasVariant: true,
            sellingPrice: 408,
            crossedPrice: 622,
            quantity: 60,
            sellingUnit: "Piece",
            productSku: "Quis rerum totam sae",
            categories: [
              {
                _id: "67c6deb32c907d0275190a77",
                categoryName: "Clothes",
              },
            ],
            allowSaleBelowMOQ: true,
            createdAt: "2025-04-01T11:54:43.537Z",
            updatedAt: "2025-04-04T10:39:09.002Z",
          },
          {
            _id: "67eb86ea94c28a7facb6fc10",
            productName: "Mechelle Luna",
            productDescription: "<p>Enter Product Descriptiondwdewqdwed</p>",
            productImages: [
              {
                name: "Screenshot 2025-03-28 164059.png",
                type: "image/png",
                size: "488249",
                publicId:
                  "66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488746522.png",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/66ade711ed3bb7773374aef4/66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488746522.png",
                _id: "67eb86ea94c28a7facb6fc11",
              },
            ],
            hasVariant: false,
            sellingPrice: 323223,
            crossedPrice: 23233,
            quantity: 2333222,
            sellingUnit: "Piece",
            productSku: "32e",
            categories: [
              {
                _id: "67dfa2f4f3edae08489f6fb0",
                categoryName: "Phone",
              },
            ],
            allowSaleBelowMOQ: true,
            createdAt: "2025-04-01T06:25:46.901Z",
            updatedAt: "2025-04-04T10:39:09.144Z",
          },
          {
            _id: "67eb861a94c28a7facb6f9e2",
            productName: "Mufutau Parsons",
            productDescription:
              "<p>With considerable experience as the former Investment Head at a leading merchant bank in Nepal, I gained a deep understanding of the dynamics of the Nepal Stock Exchange (NEPSE), where the market is primarily driven by long-term investments. With considerable experience as the former Investment Head at a leading merchant bank in Nepal, I gained a deep understanding of the dynamics of the Nepal Stock Exchange (NEPSE), where the market is primarily driven by long-term investments. With considerable experience as the former Investment Head at a leading merchant bank in Nepal, I gained a deep understanding of the dynamics of the Nepal Stock Exchange (NEPSE), where the market is primarily driven by long-term investments. With considerable experience as the former Investment Head at a leading merchant bank in Nepal, I gained a deep understanding of the dynamics of the Nepal Stock Exchange (NEPSE), where the market is primarily driven by long-term investments.&nbsp;</p>",
            productImages: [
              {
                name: "Screenshot 2025-03-21 125244.png",
                type: "image/png",
                size: "92854",
                publicId:
                  "66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488536888.png",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/66ade711ed3bb7773374aef4/66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488536888.png",
                _id: "67eb861a94c28a7facb6f9e3",
              },
              {
                name: "Screenshot 2025-03-21 125317.png",
                type: "image/png",
                size: "91151",
                publicId:
                  "66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488537281.png",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/66ade711ed3bb7773374aef4/66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488537281.png",
                _id: "67eb861a94c28a7facb6f9e4",
              },
              {
                name: "Screenshot 2025-03-23 125559.png",
                type: "image/png",
                size: "77005",
                publicId:
                  "66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488537631.png",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/66ade711ed3bb7773374aef4/66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488537631.png",
                _id: "67eb861a94c28a7facb6f9e5",
              },
              {
                name: "Screenshot 2025-03-23 170522.png",
                type: "image/png",
                size: "87371",
                publicId:
                  "66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488537999.png",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/66ade711ed3bb7773374aef4/66adf17a9eee5da87f5d6c4f/VendorProductImages/1743488537999.png",
                _id: "67eb861a94c28a7facb6f9e6",
              },
            ],
            hasVariant: false,
            sellingPrice: 99118,
            crossedPrice: 4862,
            quantity: 917,
            sellingUnit: "Piece",
            productSku: "Delectus voluptates",
            categories: [
              {
                _id: "67c928c814185374469d1889",
                categoryName: "Electronics",
              },
              {
                _id: "67c6deb32c907d0275190a77",
                categoryName: "Clothes",
              },
              {
                _id: "67bf0b88e40ce58bfc195ba4",
                categoryName: "Men's wear",
              },
            ],
            allowSaleBelowMOQ: true,
            createdAt: "2025-04-01T06:22:18.379Z",
            updatedAt: "2025-04-01T06:22:18.379Z",
          },
          {
            _id: "67ce69a9b351ee217002951c",
            productName: "No size many varaint",
            productDescription: "<p>Enter Product Descriptiond</p>",
            productImages: [
              {
                name: "green.jpg",
                type: "image/jpeg",
                size: "24478",
                publicId:
                  "66adf17a9eee5da87f5d6c4f/VendorProductImages/1741580729197.jpg",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/66ade711ed3bb7773374aef4/66adf17a9eee5da87f5d6c4f/VendorProductImages/1741580729197.jpg",
                _id: "67ce69b9b351ee217002955f",
              },
              {
                name: "red tshirt L.jpg",
                type: "image/jpeg",
                size: "194893",
                publicId:
                  "66adf17a9eee5da87f5d6c4f/VendorProductImages/1741580729579.jpg",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/66ade711ed3bb7773374aef4/66adf17a9eee5da87f5d6c4f/VendorProductImages/1741580729579.jpg",
                _id: "67ce69b9b351ee2170029560",
              },
            ],
            hasVariant: true,
            sellingPrice: null,
            crossedPrice: null,
            quantity: null,
            sellingUnit: "Piece",
            productSku: "",
            categories: [
              {
                _id: "67c6deb32c907d0275190a77",
                categoryName: "Clothes",
              },
            ],
            createdAt: "2025-03-10T04:25:13.075Z",
            updatedAt: "2025-03-30T09:32:55.919Z",
          },
          {
            _id: "67cd89528ef16ce6d7fffd5b",
            productName: "Many variants",
            productDescription: "<p>Enter Product Descriptiond</p>",
            productImages: [
              {
                name: "green.jpg",
                type: "image/jpeg",
                size: "24478",
                publicId:
                  "66adf17a9eee5da87f5d6c4f/VendorProductImages/1741760312424.jpg",
                url: "https://bpy-demo.sgp1.digitaloceanspaces.com/66ade711ed3bb7773374aef4/66adf17a9eee5da87f5d6c4f/VendorProductImages/1741760312424.jpg",
                _id: "67d12739bf246f618c0fb7bb",
              },
            ],
            hasVariant: true,
            sellingPrice: null,
            crossedPrice: null,
            quantity: null,
            sellingUnit: "Piece",
            productSku: "",
            categories: [
              {
                _id: "67c6deb32c907d0275190a77",
                categoryName: "Clothes",
              },
            ],
            createdAt: "2025-03-09T12:28:02.934Z",
            updatedAt: "2025-04-02T04:11:46.667Z",
            allowSaleBelowMOQ: false,
          },
        ],
        totalItems: 36,
      },
      null,
      2,
    ),
    Edit: JSON.stringify(
      {
        productName: "Updated Product Name",
        slug: "updated-product-name",
        productDescription: "<p>Updated description</p>",
        sellingPrice: 15,
        isActive: true,
        _id: "67f8a740eeb13afa68588b7b",
        updatedAt: "2025-04-11T06:10:42.321Z",
      },
      null,
      2,
    ),
  },
  Shipments: {
    Create: JSON.stringify(
      {
        success: true,
        data: {
          shipmentId: "9JJYPJCSR7GI",
          receiptNumber: 1055,
          vendor: {
            ownerName: "Shop Karki",
            shopName: "My Shop",
          },
          receiver: {
            name: "John Cena",
            phone: "977-9878767676-NP",
            address: "WhellyLand",
          },
          sourceBranch: {
            name: "Dolpa",
          },
          destinationBranch: {
            name: "Janakpur",
          },
          codAmount: 2500,
          weight: 0.5,
          productDescription: "Electronics - Mobile Phone",
          reference: "ORD-55421",
          status: "Pending",
          createdAt: "2026-02-25T09:37:10.678Z",
          updatedAt: "2026-02-25T09:37:10.678Z",
        },
        message: "Shipment created successfully",
      },
      null,
      2,
    ),
    Detail: JSON.stringify(
      {
        success: true,
        data: {
          shipmentId: "7L88QFWUOCNW",
          sourceBranch: "Dolpa",
          destinationBranch: "Janakpur",
          shopName: "My Shop",
          vendorName: "Shop Karki",
          receiver: "John Cena",
          phone: "977-9878767676-NP",
          address: "WhellyLand",
          shipmentStatus: "Pending",
          shipmentProcess: [
            {
              process: "Shipment Confirmed",
              description: "Shipment is created and ready for processing.",
              createdBy: "System",
              createdAt: "2026-02-12T11:38:28.166Z",
              updatedAt: "2026-02-12T11:38:28.166Z",
            },
          ],
          notes: [],
          shipmentPrices: [
            {
              charge: 2500,
              chargeType: "Cash on Delivery",
              payer: "Receiver",
              paymentStatus: "Not Paid",
            },
          ],
          createdAt: "2026-02-12T11:38:28.166Z",
          updatedAt: "2026-02-12T11:39:14.315Z",
        },
      },
      null,
      2,
    ),
    List: JSON.stringify(
      {
        success: true,
        data: {
          shipments: [
            {
              shipmentId: "3HTH86N11F80",
              status: "Pending",
              reference: "ORD-55421",
              createdAt: "2026-02-24T06:23:55.827Z",
              updatedAt: "2026-02-24T06:23:55.827Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
            {
              shipmentId: "CA7U7EMVFVBB",
              status: "Pending",
              reference: "",
              createdAt: "2026-02-13T11:23:41.453Z",
              updatedAt: "2026-02-13T11:37:36.936Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
            {
              shipmentId: "7L88QFWUOCNW",
              status: "Pending",
              reference: "ORD-55421",
              createdAt: "2026-02-12T11:38:28.166Z",
              updatedAt: "2026-02-12T11:39:14.315Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
            {
              shipmentId: "HLNF3JM2AVRU",
              status: "Pending",
              reference: "ORD-55421",
              createdAt: "2026-02-12T10:17:51.880Z",
              updatedAt: "2026-02-12T10:17:51.880Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
            {
              shipmentId: "CY3J8F6D5PX3",
              status: "Pending",
              reference: "ORD-55421",
              createdAt: "2026-02-12T10:17:49.740Z",
              updatedAt: "2026-02-12T10:17:49.740Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
            {
              shipmentId: "5KOVYM9IE3DQ",
              status: "Pending",
              reference: "ORD-55421",
              createdAt: "2026-02-12T10:17:47.729Z",
              updatedAt: "2026-02-12T10:17:47.729Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
            {
              shipmentId: "3G0UVGEPVVXG",
              status: "Pending",
              reference: "ORD-55421",
              createdAt: "2026-02-12T09:13:05.472Z",
              updatedAt: "2026-02-12T09:13:05.472Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
            {
              shipmentId: "A2W834SIP2X5",
              status: "Pending",
              reference: "ORD-55421",
              createdAt: "2026-02-12T09:12:25.993Z",
              updatedAt: "2026-02-12T09:12:25.993Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
            {
              shipmentId: "S37QR2ZME95K",
              status: "Pending",
              reference: "ORD-55421",
              createdAt: "2026-02-12T06:16:58.451Z",
              updatedAt: "2026-02-12T06:44:21.390Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
            {
              shipmentId: "0DRIGEBIEU0Q",
              status: "Pending",
              reference: "ORD-55421",
              createdAt: "2026-02-12T06:15:15.204Z",
              updatedAt: "2026-02-12T06:15:15.204Z",
              sourceBranch: "Dolpa",
              destinationBranch: "Janakpur",
            },
          ],
          pagination: {
            currentPage: 1,
            totalPages: 6,
            hasNextPage: true,
            hasPrev: false,
            totalShipments: 59,
          },
        },
      },
      null,
      2,
    ),

    Edit: JSON.stringify(
      {
        success: true,
        data: {
          shippingAddress: {
            address: "Maitidevi",
            landmark: "Temple",
          },
          _id: "67f8b71ceeb13afa68588db9",
          addedUser: "67b326f5e0a8523ad8893d0a",
          vendor: "67b326e9e0a8523ad8893cc7",
          customerProfile: "67b44e140a3e58f73badc91a",
          items: [
            {
              product: "67b04059c83949ddeb0d3577",
              quantity: 790,
              price: 823,
              _id: "67f8b810eeb13afa68588e23",
            },
            {
              product: "67c98cfbf4e96308dd0b9aa0",
              variant: "67cd6623f9c4f909dde468e7",
              quantity: 697,
              price: 558,
              _id: "67f8b810eeb13afa68588e24",
            },
          ],
          shipmentStatus: "Pending",
          deliveryNote: "Sent",
          paymentMethod: "Online",
          paymentStatus: "Pending",
          deliveryStatus: "Initiated",
          source: "Internal",
          status: "Active",
          coupon: {
            _id: "67e25acd92563f014f282468",
            entity: "66adf17a9eee5da87f5d6c4f",
            account: "66ade711ed3bb7773374aef4",
            code: "Porro veniam animi",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Percentage",
            discountValue: 44,
            minPurchaseAmount: 83,
            maxDiscountAmount: 83,
            expiryDate: "2025-04-25T00:00:00.000Z",
            usageLimit: 33,
            usedCount: 5,
            status: "Active",
            createdAt: "2025-03-25T07:27:09.716Z",
            updatedAt: "2025-04-09T09:41:46.243Z",
            __v: 0,
            shipments: [
              "67ece50fe9264bd910ec381b",
              "67ece5ece9264bd910ec3a0c",
              "67f63c3a10d1c32f3726418a",
              "67f6409310d1c32f372642f4",
              "67f640da10d1c32f37264308",
            ],
          },
          notes: [
            {
              comment: "Shipment was manually created",
              type: "Auto",
              isActive: true,
              _id: "67f8b71ceeb13afa68588dbc",
              attachments: [],
              createdAt: "2025-04-11T06:30:52.123Z",
              updatedAt: "2025-04-11T06:30:52.123Z",
            },
            {
              comment:
                "<strong>Payment Method Updated:</strong> from <em>Cash</em> to <em>Online</em>",
              type: "Auto",
              isActive: true,
              _id: "67f8b810eeb13afa68588e25",
              createdAt: "2025-04-11T06:34:56.008Z",
              updatedAt: "2025-04-11T06:34:56.008Z",
              attachments: [],
            },
          ],
          createdAt: "2025-04-11T06:30:52.123Z",
          updatedAt: "2025-04-11T06:34:56.008Z",
          shipmentId: "AVZTW7GH8NB5",
          __v: 0,
        },
      },
      null,
      2,
    ),
  },
  Category: {
    Create: JSON.stringify(
      {
        data: [
          {
            _id: "67f8b8dfeeb13afa68588ee3",
            categoryName: "Cassandra Day",
            slug: "cassandra-day",
            categoryDescription: "<p>Live animal handle with care</p>",
            status: "Active",
            createdAt: "2025-04-11T06:38:23.893Z",
            updatedAt: "2025-04-11T06:38:23.893Z",
            packageTypeDetails: {
              name: "Live Animals",
            },
          },
          {
            _id: "67f89f93eeb13afa68588b20",
            categoryName: "Noel Holc333omb",
            slug: "noel-holc333omb",
            categoryDescription: "<p>Category description</p>",
            status: "Active",
            createdAt: "2025-04-11T04:50:27.780Z",
            updatedAt: "2025-04-11T04:50:27.780Z",
            packageTypeDetails: {
              name: "Live Animals",
            },
          },
          {
            _id: "67f89ed1eeb13afa68588aea",
            categoryName: "Noel Holcomb",
            slug: "noel-holcomb",
            categoryDescription: "<p>Category description</p>",
            status: "Active",
            createdAt: "2025-04-11T04:47:13.065Z",
            updatedAt: "2025-04-11T04:47:13.065Z",
            packageTypeDetails: {
              name: "Live Animals",
            },
          },
          {
            _id: "67f793f8092d1394c9db0f92",
            categoryName: "Heheheh hshss",
            slug: "heheheh-hshss",
            categoryDescription: "<p>Hshshw</p>",
            status: "Active",
            createdAt: "2025-04-10T09:48:40.897Z",
            updatedAt: "2025-04-10T11:01:04.902Z",
            packageTypeDetails: {
              name: "Pet Waste Bag Dispensers & Holders",
            },
          },
          {
            _id: "67f6594dc9e7f8185ca63cba",
            categoryName: "Yun and get ",
            slug: "yun-and-get-",
            categoryDescription: "Haisissbbiddbidid. Jdidbd is d",
            status: "Active",
            createdAt: "2025-04-09T11:26:05.560Z",
            updatedAt: "2025-04-09T11:26:05.560Z",
            packageTypeDetails: {
              name: "Pet Waste Bag Dispensers & Holders",
            },
          },
          {
            _id: "67f6507ec9e7f8185ca638c9",
            categoryName: "Hshdfb",
            slug: "hshdfb",
            categoryDescription: "Smbisisxisbsx",
            status: "Active",
            createdAt: "2025-04-09T10:48:30.814Z",
            updatedAt: "2025-04-09T10:48:30.814Z",
            packageTypeDetails: {
              name: "Aquarium & Pond Tubing",
            },
          },
          {
            _id: "67f65024c9e7f8185ca63895",
            categoryName: "Cattt",
            slug: "cattt",
            categoryDescription: "Jawjwh",
            status: "Active",
            createdAt: "2025-04-09T10:47:00.181Z",
            updatedAt: "2025-04-09T10:47:00.181Z",
            packageTypeDetails: {
              name: "Event Tickets",
            },
          },
          {
            _id: "67f64b01c9e7f8185ca63437",
            categoryName: "ffs",
            slug: "ffs",
            categoryDescription: "<p>Enter Category Descriptionbfsdgwsf</p>",
            status: "Active",
            createdAt: "2025-04-09T10:25:05.386Z",
            updatedAt: "2025-04-09T10:30:53.787Z",
            packageTypeDetails: {
              name: "Non-prescription Dog Food",
            },
          },
          {
            _id: "67f64077c9e7f8185ca62beb",
            categoryName: "Graham Watts",
            slug: "graham-watts",
            categoryDescription: "<p>Enter Category Description fgvdfgdg</p>",
            status: "Active",
            createdAt: "2025-04-09T09:40:07.823Z",
            updatedAt: "2025-04-09T09:40:07.823Z",
            packageTypeDetails: {
              name: "Event Tickets",
            },
          },
          {
            _id: "67f2241391497b53dde09308",
            categoryName: "Tyler Padilla",
            slug: "tyler-padilla",
            categoryDescription: "<p>Enter Category Descriptioncsdc</p>",
            status: "Active",
            createdAt: "2025-04-06T06:49:55.785Z",
            updatedAt: "2025-04-06T06:49:55.785Z",
            packageTypeDetails: {
              name: "Aquarium & Pond Tubing",
            },
          },
        ],
        totalItems: 17,
      },
      null,
      2,
    ),
    List: JSON.stringify(
      {
        data: [
          {
            _id: "67f89f93eeb13afa68588b20",
            categoryName: "Noel Holc333omb",
            slug: "noel-holc333omb",
            categoryDescription: "<p>Category description</p>",
            status: "Active",
            createdAt: "2025-04-11T04:50:27.780Z",
            updatedAt: "2025-04-11T04:50:27.780Z",
            packageTypeDetails: {
              name: "Live Animals",
            },
          },
          {
            _id: "67f89ed1eeb13afa68588aea",
            categoryName: "Noel Holcomb",
            slug: "noel-holcomb",
            categoryDescription: "<p>Category description</p>",
            status: "Active",
            createdAt: "2025-04-11T04:47:13.065Z",
            updatedAt: "2025-04-11T04:47:13.065Z",
            packageTypeDetails: {
              name: "Live Animals",
            },
          },
          {
            _id: "67f793f8092d1394c9db0f92",
            categoryName: "Heheheh hshss",
            slug: "heheheh-hshss",
            categoryDescription: "<p>Hshshw</p>",
            status: "Active",
            createdAt: "2025-04-10T09:48:40.897Z",
            updatedAt: "2025-04-10T11:01:04.902Z",
            packageTypeDetails: {
              name: "Pet Waste Bag Dispensers & Holders",
            },
          },
          {
            _id: "67f6594dc9e7f8185ca63cba",
            categoryName: "Yun and get ",
            slug: "yun-and-get-",
            categoryDescription: "Haisissbbiddbidid. Jdidbd is d",
            status: "Active",
            createdAt: "2025-04-09T11:26:05.560Z",
            updatedAt: "2025-04-09T11:26:05.560Z",
            packageTypeDetails: {
              name: "Pet Waste Bag Dispensers & Holders",
            },
          },
          {
            _id: "67f6507ec9e7f8185ca638c9",
            categoryName: "Hshdfb",
            slug: "hshdfb",
            categoryDescription: "Smbisisxisbsx",
            status: "Active",
            createdAt: "2025-04-09T10:48:30.814Z",
            updatedAt: "2025-04-09T10:48:30.814Z",
            packageTypeDetails: {
              name: "Aquarium & Pond Tubing",
            },
          },
          {
            _id: "67f65024c9e7f8185ca63895",
            categoryName: "Cattt",
            slug: "cattt",
            categoryDescription: "Jawjwh",
            status: "Active",
            createdAt: "2025-04-09T10:47:00.181Z",
            updatedAt: "2025-04-09T10:47:00.181Z",
            packageTypeDetails: {
              name: "Event Tickets",
            },
          },
          {
            _id: "67f64b01c9e7f8185ca63437",
            categoryName: "ffs",
            slug: "ffs",
            categoryDescription: "<p>Enter Category Descriptionbfsdgwsf</p>",
            status: "Active",
            createdAt: "2025-04-09T10:25:05.386Z",
            updatedAt: "2025-04-09T10:30:53.787Z",
            packageTypeDetails: {
              name: "Non-prescription Dog Food",
            },
          },
          {
            _id: "67f64077c9e7f8185ca62beb",
            categoryName: "Graham Watts",
            slug: "graham-watts",
            categoryDescription: "<p>Enter Category Description fgvdfgdg</p>",
            status: "Active",
            createdAt: "2025-04-09T09:40:07.823Z",
            updatedAt: "2025-04-09T09:40:07.823Z",
            packageTypeDetails: {
              name: "Event Tickets",
            },
          },
          {
            _id: "67f2241391497b53dde09308",
            categoryName: "Tyler Padilla",
            slug: "tyler-padilla",
            categoryDescription: "<p>Enter Category Descriptioncsdc</p>",
            status: "Active",
            createdAt: "2025-04-06T06:49:55.785Z",
            updatedAt: "2025-04-06T06:49:55.785Z",
            packageTypeDetails: {
              name: "Aquarium & Pond Tubing",
            },
          },
          {
            _id: "67f2240391497b53dde092f2",
            categoryName: "Sybil Serrano",
            slug: "sybil-serrano",
            categoryDescription: "<p>Enter Category Description wscvsd</p>",
            status: "Active",
            createdAt: "2025-04-06T06:49:39.695Z",
            updatedAt: "2025-04-06T06:49:39.695Z",
            packageTypeDetails: {
              name: "Candle Making Kits",
            },
          },
        ],
        totalItems: 16,
      },
      null,
      2,
    ),
    Edit: JSON.stringify(
      {
        _id: "67f8b8dfeeb13afa68588ee3",
        addedUser: "67b326f5e0a8523ad8893d0a",
        categoryName: "Cassandra Day",
        slug: "cassandra-day",
        categoryDescription: "<p>Live animal handle with care test</p>",
        packageType: "61b6d5a3bd5be8b2681114ac",
        parentCategory: null,
        status: "Active",
        vendor: "67b326e9e0a8523ad8893cc7",
        createdAt: "2025-04-11T06:38:23.893Z",
        updatedAt: "2025-04-11T06:38:49.410Z",
        __v: 0,
      },
      null,
      2,
    ),
  },

  Leads: {
    List: JSON.stringify(
      {
        data: [
          {
            _id: "67f7a4137f36f2dbee927c7d",
            name: "Hshsu",
            email: "bhusan@doteeeel.com",
            phone: "64646",
            address: "Shhshs",
            description: "Shhshs",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "New",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-10T10:57:23.129Z",
            updatedAt: "2025-04-10T10:57:23.129Z",
            __v: 0,
          },
          {
            _id: "67f75b190d0f64b5ba284d52",
            name: "Cade Hoffman",
            email: "laxycysude@mailinator.com",
            phone: "+1 (705) 373-7944",
            address: "Ad voluptatem Adipi",
            description: "Beatae et tempora do",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "New",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-10T05:46:01.678Z",
            updatedAt: "2025-04-10T05:46:10.650Z",
            __v: 0,
          },
          {
            _id: "67f66075c9e7f8185ca6473f",
            name: "Ususu",
            email: "hshdhdysgshdhdjdsj@gmail.com",
            phone: "659465946",
            address: "Hshshs",
            description: "Hshs",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "New",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-09T11:56:37.923Z",
            updatedAt: "2025-04-10T05:45:48.098Z",
            __v: 0,
          },
          {
            _id: "67f65db7c9e7f8185ca643da",
            name: "",
            email: "",
            phone: "",
            address: "",
            description: "",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "New",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-09T11:44:55.712Z",
            updatedAt: "2025-04-09T11:44:55.712Z",
            __v: 0,
          },
          {
            _id: "67f65d70c9e7f8185ca64319",
            name: "Nissan haha",
            email: "nisghsh@gmail.com",
            phone: "9823232448",
            address: "Balkhu",
            description: "Hahaha sjs",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "New",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-09T11:43:44.238Z",
            updatedAt: "2025-04-09T11:43:44.238Z",
            __v: 0,
          },
          {
            _id: "67f65a25c9e7f8185ca63ddd",
            name: "Cruz Robles",
            email: "woqu@mailinator.com",
            phone: "+1 (448) 963-6987",
            address: "Sit ea soluta iusto ",
            description: "Pariatur Sapiente d",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "New",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-09T11:29:41.015Z",
            updatedAt: "2025-04-09T11:29:41.015Z",
            __v: 0,
          },
          {
            _id: "67f5f4f98ff6d2ff9365e836",
            name: "Lisandra Carlson",
            email: "fucesyluho@mailinator.com",
            phone: "+1 (678) 478-5626",
            address: "Deleniti error et re",
            description: "Quibusdam reprehende",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "Converted",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-09T04:18:01.133Z",
            updatedAt: "2025-04-09T04:18:09.180Z",
            __v: 0,
            connectedCustomer: "67f5f5018ff6d2ff9365e86b",
          },
          {
            _id: "67f5f39c8ff6d2ff9365e69a",
            name: "Deborah Craft",
            email: "pihumebyc@mailinator.com",
            phone: "+1 (439) 552-6254",
            address: "Eos eveniet culpa ",
            description: "Nulla consequuntur q",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "Rejected",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-09T04:12:12.716Z",
            updatedAt: "2025-04-09T04:17:36.517Z",
            __v: 0,
          },
          {
            _id: "67f26b48cca0e0ca191fa5fb",
            name: "Dominic Mcneil",
            email: "havyhalu@mailinator.com",
            phone: "+1 (403) 293-9546",
            address: "Maxime fugit lorem ",
            description: "Necessitatibus place",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "Converted",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-06T11:53:44.486Z",
            updatedAt: "2025-04-06T11:53:49.462Z",
            __v: 0,
            connectedCustomer: "67f26b4dcca0e0ca191fa60e",
          },
          {
            _id: "67f26975ebbf1563b9eb28d1",
            name: "Reuben Mcconnell",
            email: "qefujyt@mailinator.com",
            phone: "+1 (567) 701-5545",
            address: "Aliquid earum rerum ",
            description: "Tenetur molestiae ar",
            vendor: "67b326e9e0a8523ad8893cc7",
            status: "Converted",
            source: "Internal",
            isActive: true,
            createdAt: "2025-04-06T11:45:57.159Z",
            updatedAt: "2025-04-06T11:46:00.641Z",
            __v: 0,
            connectedCustomer: "67f26978ebbf1563b9eb28e4",
          },
        ],
        totalSize: 17,
      },
      null,
      2,
    ),
  },

  Coupon: {
    Create: JSON.stringify(
      {
        code: "Sint sint exercitat",
        vendor: "67b326e9e0a8523ad8893cc7",
        discountType: "Percentage",
        discountValue: 18,
        minPurchaseAmount: 8,
        maxDiscountAmount: 73,
        expiryDate: "2025-05-03T13:21:00.000Z",
        usageLimit: 100,
        usedCount: 0,
        status: "Active",
        description: "Sit molestiae rerum",
        shipments: [],
        _id: "67f8e7185cdfd4648f223c12",
        createdAt: "2025-04-11T09:55:36.060Z",
        updatedAt: "2025-04-11T09:55:36.060Z",
        __v: 0,
        isExpired: false,
        isExhausted: false,
        id: "67f8e7185cdfd4648f223c12",
      },
      null,
      2,
    ),
    List: JSON.stringify(
      {
        data: [
          {
            _id: "67f8e7185cdfd4648f223c12",
            code: "Quos nostrum sit rer",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Percentage",
            discountValue: 43,
            minPurchaseAmount: 25,
            maxDiscountAmount: 80,
            expiryDate: "2025-04-28T23:15:00.000Z",
            usageLimit: 66,
            usedCount: 0,
            status: "Active",
            description: "Dolore laudantium m",
            shipments: [],
            createdAt: "2025-04-11T09:55:36.060Z",
            updatedAt: "2025-04-11T09:57:54.377Z",
            __v: 0,
          },
          {
            _id: "67f7a5807f36f2dbee927ed5",
            code: "OQN3VTIV",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Percentage",
            discountValue: 5454,
            minPurchaseAmount: 545,
            maxDiscountAmount: 6461,
            expiryDate: "2025-07-10T11:03:00.000Z",
            usageLimit: 4664,
            usedCount: 0,
            status: "Active",
            description: "Gshshshshsgs",
            shipments: [],
            createdAt: "2025-04-10T11:03:28.453Z",
            updatedAt: "2025-04-10T11:03:28.453Z",
            __v: 0,
          },
          {
            _id: "67f79424092d1394c9db0fac",
            code: "J4PXSX1J",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Fixed",
            discountValue: 6464,
            minPurchaseAmount: 4664,
            maxDiscountAmount: 7646,
            expiryDate: "2025-05-10T09:48:00.000Z",
            usageLimit: 555,
            usedCount: 0,
            status: "Active",
            description: "Hshshs\n",
            shipments: [],
            createdAt: "2025-04-10T09:49:24.874Z",
            updatedAt: "2025-04-10T09:52:43.560Z",
            __v: 0,
          },
          {
            _id: "67f7867b092d1394c9dafffb",
            code: "E9ZCQDSL",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Percentage",
            discountValue: 85,
            minPurchaseAmount: 50,
            maxDiscountAmount: 41,
            expiryDate: "2025-04-18T14:35:00.000Z",
            usageLimit: 16,
            usedCount: 0,
            status: "Active",
            description: "Similique reprehende",
            shipments: [],
            createdAt: "2025-04-10T08:51:07.944Z",
            updatedAt: "2025-04-10T08:52:04.843Z",
            __v: 0,
          },
          {
            _id: "67f76dfd092d1394c9dae7f2",
            code: "DU5E9ED7",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Fixed",
            discountValue: 642,
            minPurchaseAmount: 3446,
            maxDiscountAmount: 6464,
            expiryDate: "2025-05-10T06:17:00.000Z",
            usageLimit: 4646,
            usedCount: 0,
            status: "Active",
            description: "Zbbz",
            shipments: [],
            createdAt: "2025-04-10T07:06:37.245Z",
            updatedAt: "2025-04-10T07:06:37.245Z",
            __v: 0,
          },
          {
            _id: "67f76229092d1394c9dade39",
            code: "BHUX8H7C",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Percentage",
            discountValue: 255,
            minPurchaseAmount: 556,
            maxDiscountAmount: 25,
            expiryDate: "2025-05-14T06:11:00.000Z",
            usageLimit: 5388,
            usedCount: 1,
            status: "Active",
            description: "Bshdhdhdsj",
            shipments: ["67f7b3548eae0fb077470fb7"],
            createdAt: "2025-04-10T06:16:09.458Z",
            updatedAt: "2025-04-10T12:02:28.136Z",
            __v: 0,
          },
          {
            _id: "67f7482e092d1394c9dabdb5",
            code: "Eum occaecat culpa ",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Fixed",
            discountValue: 222,
            minPurchaseAmount: 71,
            maxDiscountAmount: 82,
            expiryDate: "2026-01-17T10:45:00.000Z",
            usageLimit: 91,
            usedCount: 0,
            status: "Active",
            description: "Ipsum eiusmod esse",
            shipments: [],
            createdAt: "2025-04-10T04:25:18.315Z",
            updatedAt: "2025-04-10T04:27:12.395Z",
            __v: 0,
          },
          {
            _id: "67eff5597fe73c55f0b5db6d",
            entity: "66adf17a9eee5da87f5d6c4f",
            account: "66ade711ed3bb7773374aef4",
            code: "VYJWWSPN",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Fixed",
            discountValue: 68,
            minPurchaseAmount: 53,
            maxDiscountAmount: 86,
            expiryDate: "2025-04-24T22:31:00.000Z",
            usageLimit: 68,
            usedCount: 0,
            status: "Active",
            description: "Delectus eu volupta",
            shipments: [],
            createdAt: "2025-04-04T15:06:01.708Z",
            updatedAt: "2025-04-04T15:06:01.708Z",
            __v: 0,
          },
          {
            _id: "67efb0e6ee298dffe917e948",
            entity: "66adf17a9eee5da87f5d6c4f",
            account: "66ade711ed3bb7773374aef4",
            code: "SM37AV90",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Fixed",
            discountValue: 26,
            minPurchaseAmount: 50,
            maxDiscountAmount: 30,
            expiryDate: "2025-04-22T06:28:00.000Z",
            usageLimit: 15,
            usedCount: 0,
            status: "Active",
            description: "Molestias praesentiu",
            shipments: [],
            createdAt: "2025-04-04T10:13:58.791Z",
            updatedAt: "2025-04-04T10:13:58.791Z",
            __v: 0,
          },
          {
            _id: "67ed036a8628abcf04e5f249",
            entity: "66adf17a9eee5da87f5d6c4f",
            account: "66ade711ed3bb7773374aef4",
            code: "WC9QONZ3",
            vendor: "67b326e9e0a8523ad8893cc7",
            discountType: "Percentage",
            discountValue: 85,
            minPurchaseAmount: 21,
            maxDiscountAmount: 67,
            expiryDate: "2025-05-24T16:55:00.000Z",
            usageLimit: 56,
            usedCount: 4,
            status: "Active",
            description: "Accusantium corporis",
            shipments: [
              "67ed1a37712cfb41623412d4",
              "67ee037e525f15ed4d1ccd0d",
              "67ee13d9d1e73203431dcd5c",
              "67f7b3d48eae0fb0774711e8",
            ],
            createdAt: "2025-04-02T09:29:14.378Z",
            updatedAt: "2025-04-10T12:04:36.229Z",
            __v: 0,
          },
        ],
        totalItems: 22,
      },
      null,
      2,
    ),
    Edit: JSON.stringify(
      {
        _id: "67f8e7185cdfd4648f223c12",
        code: "Quos nostrum sit rer",
        vendor: "67b326e9e0a8523ad8893cc7",
        discountType: "Percentage",
        discountValue: 43,
        minPurchaseAmount: 25,
        maxDiscountAmount: 80,
        expiryDate: "2025-04-28T23:15:00.000Z",
        usageLimit: 66,
        usedCount: 0,
        status: "Active",
        description: "Dolore laudantium m",
        shipments: [],
        createdAt: "2025-04-11T09:55:36.060Z",
        updatedAt: "2025-04-11T09:57:54.377Z",
        __v: 0,
        isExpired: false,
        isExhausted: false,
        id: "67f8e7185cdfd4648f223c12",
      },
      null,
      2,
    ),
  },
};
